/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ first: NonNullable<unknown>, second: NonNullable<unknown> }} Endpoint_Play_FailedInputs */

const en_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Example call: ${i?.first} failed, trying ${i?.second}.`)
};

const zh_hans1_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`示例调用：${i?.first} 失败，正在尝试 ${i?.second}。`)
};

const pt_br2_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chamada de exemplo: ${i?.first} falhou, tentando ${i?.second}.`)
};

const es_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llamada de ejemplo: ${i?.first} falló, probando ${i?.second}.`)
};

const fr_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exemple d’appel : ${i?.first} a échoué, essai de ${i?.second}.`)
};

const de_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Beispielaufruf: ${i?.first} ist ausgefallen, ${i?.second} wird versucht.`)
};

const ru_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пример вызова: ${i?.first} не ответил, пробуем ${i?.second}.`)
};

const it_endpoint_play_failed = /** @type {(inputs: Endpoint_Play_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chiamata di esempio: ${i?.first} ha fallito, provo con ${i?.second}.`)
};

/**
* | output |
* | --- |
* | "Example call: {first} failed, trying {second}." |
*
* @param {Endpoint_Play_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_play_failed = /** @type {((inputs: Endpoint_Play_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Play_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_play_failed(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_play_failed(inputs)
	if (locale === "es") return es_endpoint_play_failed(inputs)
	if (locale === "fr") return fr_endpoint_play_failed(inputs)
	if (locale === "de") return de_endpoint_play_failed(inputs)
	if (locale === "ru") return ru_endpoint_play_failed(inputs)
	if (locale === "it") return it_endpoint_play_failed(inputs)
	return en_endpoint_play_failed(inputs)
});